import { Component, OnInit, OnDestroy, SecurityContext, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { VantageShellService } from 'src/app/services/vantage-shell/vantage-shell.service';
import { TimerService } from 'src/app/services/timer/timer.service';

@Component({
	selector: 'vtr-modal-license',
	templateUrl: './modal-license.component.html',
	styleUrls: ['./modal-license.component.scss'],
	providers: [TimerService]
})
export class ModalLicenseComponent implements OnInit, OnDestroy {

	url: string;
	localUrl: string;
	/** type will be 'html' or 'txt' */
	type: string;
	articleBody: SafeHtml = '';
	licenseModalMetrics: any;
	pageDuration: number;
	loading = true;
	iframeInterval: any;
	getOpenSourceTimeout: ReturnType<typeof setTimeout>;
	openSource: any;

	constructor(
		public activeModal: NgbActiveModal,
		private http: HttpClient,
		private sanitizer: DomSanitizer,
		private shellService: VantageShellService,
		private timerService: TimerService
	) {	}

	ngOnInit() {
		window.getSelection().empty();
		if (this.type === 'txt') {
			this.getOpenSource(this.url);
		} else {
			this.loading = false;
			this.setIframeUrl();
		}
		this.timerService.start();
		setTimeout(() => {
			(document.querySelector('#license-dialog-empty') as HTMLElement).focus();
		}, 0);
	}

	ngOnDestroy() {	}

	setIframeUrl() {
		const iframe: any = document.querySelector('#license-agreement-iframe');
		iframe.src = this.url;
		this.iframeInterval = setInterval(() => {
			if (iframe.contentWindow) {
				iframe.contentWindow.addEventListener('mousewheel', (event: any) => {
					if (event.ctrlKey === true || event.metaKey) {
						event.preventDefault();
					}
				}, false);
				clearInterval(this.iframeInterval);
			}
		}, 50);
	}

	getOpenSource(url: string) {
		this.getOpenSourceTimeout = setTimeout(() => {
			this.getLocalOpenSource();
		}, 1000);
		this.openSource = this.shellService.getOpenSource();
		if(this.openSource){
			this.openSource.getOnlineOpenSourceLicense(url).then((results)=>{
				clearTimeout(this.getOpenSourceTimeout);
				this.showOpenSource(results);
			}).catch((error)=>{
				clearTimeout(this.getOpenSourceTimeout);
				this.getLocalOpenSource();
			});
		}
		else{
			clearTimeout(this.getOpenSourceTimeout);
			this.getLocalOpenSource();
		}
	}

	getLocalOpenSource(){
		this.http.get(this.localUrl, { responseType: "text" }).subscribe((results: any)=>{
			this.showOpenSource(results);
		});
	}

	showOpenSource(openSourceContent: any){
		this.loading = false;
		const result = openSourceContent.replace(/\< /g, '<').replace(/ \>/g, '>').replace(/\</g, '< ').replace(/\>/g, ' >');
		this.articleBody = `<pre>${result}</pre>`;
	}
	

	closeModal() {
		this.activeModal.close('close');
		document.getElementById('support-about-lenovo-vantage').focus();
	}

	@HostListener('window: focus')
	onFocus(): void {
		if (!this.licenseModalMetrics || !this.licenseModalMetrics.closeButton || document.activeElement.id !== `btn-${this.licenseModalMetrics.closeButton}`) {
			(document.querySelector('.license-Modal') as HTMLElement).focus();
		}
	}
}
